import BreadCrumb from "../components/BreadCrumb/breadCrumb";
import Gallery from "../components/Gallery/gallery";
export default function PortfolioPage() {
    return (
        <>
            <BreadCrumb id="portfolio" desc="Make your business very easy with us." title="Our Success Stories" />
            <div className="portfolio-title">
                <div className="portfolio-title-border">
                    <h3>Portfolio</h3>
                </div>
            </div>
            <Gallery />
        </>
    )
}